'use strict';

import modal from '../../modal';
import progress from '../../progress';
import validator from '../../validator';


function initializeEvents() {
    $(document).on('click', '#emailcheck, #login_only, #guestcheckout', function(e){    	
        progress.show('.modal-content');
        showLoginCheckout(e,this);
    });
}

    
function showLoginCheckout(e,thisObj){
	  e.preventDefault();
	  
    var post_url =  $(thisObj).closest('form').attr('action'); //get form action url
    
    var form_data = $(thisObj).attr('name')+'='+$(thisObj).attr('name')+'&format=ajax&';
    form_data = form_data+$(thisObj).closest('form').serialize(); //Encode form elements for submission
    	    
    $.ajax({
    	url : post_url,
    	type : 'POST',
    	data : form_data	    	
    }).then(function(response){  	
    	if(typeof response == 'object' && response.redirect == true){	    		
    		window.location.href = response.redirectURL;	    		
    	}else{
    		modal.setCallback(function () {	                
    			checkSocialLogin();
            });
    		modal.renderContent(response);	
    	}
    	progress.hide();
    	$('.reveal').addClass('checkout-login-popup');
    	$('.checkout-login-popup .username').addClass('focus-in');
        $('.checkout-login-popup .username .input-text').val() && $('<i class=\'icon_checkmark\'></i>').insertBefore('.checkout-login-popup .username .input-text');
    });
    
    /*
     * Checkout Login functionality
     */
    modal.events.onClose(function () {
        var socialLoginContent = $('#modal-content').find('.social-login-content');
        if(socialLoginContent.length > 0){
            $('#social-login-wrapper').html($(socialLoginContent).html());
        }
        modal.restoreDefaultClass();
    });

}

/*
 * Social Login function
 */
function checkSocialLogin(){
    //re-initiate the call
    var $checkoutLoginForm =  $('#modal-content').find('form[name="login-form"]');
    validator.initForm($checkoutLoginForm);
	
    var $checkoutGuestForm =  $('#modal-content').find('form[name="guest-form"]');
    validator.initForm($checkoutGuestForm);
	
    var socialLoginContent = $('#modal-content').find('.social-login-content');
    var socialLoginWrapper = $('#modal-content').find('#social-login-wrapper');
	
    if(socialLoginContent.length > 0 && socialLoginWrapper.length == 0){	
        var socialData = $('#social-login-wrapper').html();
        $('#social-login-wrapper').empty();
	
        $(socialLoginContent).html(socialData);			
    }
}

export default {
    init: function () {
        initializeEvents();   
    }
};
